/**
 * Production API origin.
 *
 * The Store frontend and API are served from the same domain:
 * https://store.newjourneyofficial.com
 *
 * Therefore the browser uses /api and no separate API hostname is required.
 */

const PRODUCTION_BACKEND_URL = "";

function isLocalHost(hostname: string): boolean {
  return hostname === "localhost" || hostname === "127.0.0.1";
}

export function getBackendBaseUrl(): string {
  const fromBuild = process.env.REACT_APP_BACKEND_URL?.trim();
  const isProdBuild = process.env.NODE_ENV === "production";
  const onDeployedHost =
    typeof window !== "undefined" && !isLocalHost(window.location.hostname);

  if (onDeployedHost || isProdBuild) {
    return PRODUCTION_BACKEND_URL;
  }

  return fromBuild?.replace(/\/$/, "") || "http://localhost:5102";
}

export const API_BASE = `${getBackendBaseUrl()}/api`;
